export default __webpack_public_path__ + "static/media/twokitty-ball.7f55ac09.png";